<script setup lang="ts">
const showLess = ref(true);

const props = defineProps({
  text: {
    type: String,
    required: false,
    default: ''
  },
  max: {
    type: Number,
    required: true
  },
  interactive: {
    type: Boolean,
    default: false
  }
});

const hasTruncated = !!(props.text && props.text.length > props.max);

const truncatedText = computed(() => hasTruncated ? (props.text.substring(0, props.max) + '...') : props.text);

const toggleText = () => showLess.value = !showLess.value;
</script>

<template>
  <span>
    <span v-html="showLess ? truncatedText : text"></span>&nbsp;
    <button v-if="interactive && hasTruncated" @click.prevent="toggleText" aria-label="More" class="text-violet-800 dark:text-primary">
      {{ showLess ? 'More' : 'Less' }}
    </button>
  </span>
</template>

<style scoped>

</style>